import { Point } from "../Point";
import { Rectangle } from "../Rectangle";
import { Id_asset, Id_category, Id_floor, Id_location } from "../api/Identifiers";
import { Category, CategoryCollection } from "../Categories";
import { exists } from "../utils";
import { MapFeature } from "../MapFeature";
import { Configuration } from "../Configuration";


interface AssetJSON {
    adj_coords: number[];
    adjP1P2: any[];
    category: number;
    coords: number[];
    icon: string;
    id_asset: string;   // id_asset is a UUID
    id_location: number;
    id_floor: number;
    rawCoords: number[];
    rawP1P2: number[];
    has_coords: boolean;
}

export class Asset extends MapFeature {
    private _raw_coord: Point;
    // private _adj_coord: Point;
    private _raw_geo_ref: Rectangle;
    // private _adj_geo_ref: Rectangle;
    private _icon: string;
    private _id: Id_asset;
    private _category: string;
    private _id_category: Id_category = null;
    private _id_location: Id_location;
    private _id_floor: Id_floor;
    private _raw: any;
    private _has_coords: boolean = true;

    // MapFeature required methods
    //    public static readonly MAP_FEATURE_TYPE: string = "asset"
    //    public get adj_coords(): Point { return this._adj_coord }
    //    private _adj_cluster_coords:Point;
    //    public get adj_cluster_coords(): Point { return this._adj_cluster_coords }
    //    public set_adj_cluster_coords(p:Point):void{ this._adj_cluster_coords=p; }
    //    public set_adj_coords(p:Point, p1p2:Rectangle):void {this._adj_coord=p; this._adj_geo_ref=p1p2; this.set_adj_cluster_coords(p);}
    

    public isValid: boolean = true; 
    public get generic_id(): string { return this.id.toString(); }
    public get icon_url(): string { return this._icon; }

    public get raw_geo_ref(): Rectangle { return this._raw_geo_ref; }
    public get map_feature_type(): string { return "asset"; }

    get id_floor(): Id_floor {
        if (!this._id_floor) {
            return this._id_location;
        }
        return this._id_floor;
    }

    public get id(): Id_asset {
        return this._id;
    }

    public set_category(categories: CategoryCollection) {
        this._category = categories.find(this._id_category).label;
    }

    public get category(): string {
        return this._category;
    }

    // private get adj_coord(): Point {
    //     let ret_val: Point = this._adj_coord;
    //     if (!ret_val) {
    //         ret_val = this.raw_coord;
    //         if (!ret_val) {
    //             ret_val = Point.NULL;
    //         }
    //     }
    //     return ret_val;
    // }

    // public get adj_geo_ref(): Rectangle {
    //     let ret_val: Rectangle = this._adj_geo_ref;
    //     if (!ret_val) {
    //         ret_val = this._raw_geo_ref;
    //         if (!ret_val) {
    //             ret_val = Rectangle.NULL;
    //         }
    //     }
    //     return ret_val;
    // }

    public get raw_coords(): Point|null {
        return this._raw_coord;

    }
    public get id_category(): Id_category {
        return this._id_category;

    }

    public get raw(): any {
        return this._raw;
    }

    public static build_from_raw(raw_asset: any, categories?: CategoryCollection): Asset {

        let r: Asset = new Asset;
        if (raw_asset.asset) {
            // sometimes the raw asset is buried under an asset field
            raw_asset = raw_asset.asset;
        }
        r._raw = Object.assign({}, raw_asset);

        r._id = Id_asset.wrap(raw_asset.id);
        if (!r._id) {
            r._id = Id_asset.wrap(raw_asset.idAsset);
        }
        if (!r._id) {
            console.debug("asset is missing an id field");
            return null;
        }
        r._id_category = Id_category.wrap(raw_asset.idCategory);
        if (!r._id_category) {
            console.debug("Asset" + r._id.toString() + " is missing required idCategory field.");
            return null;
        }
        r._category = r._id_category.toString();
        r._id_location = Id_location.wrap(raw_asset.idLocation);
        r._id_floor = Id_floor.wrap(raw_asset.idFloor);
        r._raw_coord = Point.build(raw_asset.xCoord, raw_asset.yCoord);

        if (!r._raw_coord) {
            r._raw_coord = Point.build(0, 0);
        }

        if (categories) {
            r.set_category(categories);
        }

        r._icon = utilsAssetIcon(raw_asset.icon);

        if (!r._icon) {
            r._icon = utilsAssetIcon(raw_asset.cmsViewIcon);
        }

        if (exists(raw_asset.p1xCoord)) {
            r._raw_geo_ref = Rectangle.build_from_numbers(raw_asset.p1xCoord,
                raw_asset.p1yCoord,
                raw_asset.p2xCoord,
                raw_asset.p2yCoord);
        }
        else {
            r._raw_geo_ref = Rectangle.build_from_numbers(raw_asset.p1XCoord,
                raw_asset.p1YCoord,
                raw_asset.p2XCoord,
                raw_asset.p2YCoord);
        }

        if (!r._raw_geo_ref) {
            // awh todo: reject this asset. don't store it
            r._raw_geo_ref = Rectangle.NULL;
        }
        return r;
    }

    public get has_coords(): boolean { return exists(this.raw_coords); }

    public get as_json(): AssetJSON {
        const r: AssetJSON = {
            adj_coords: this.adj_coords.as_json,
            adjP1P2: this.adj_geo_ref.toJSON(),
            coords: this.adj_coords.toJSON(),
            category: this._id_category.value,
            icon: this._icon,
            id_asset: this._id.value,
            id_location: this.id_floor.value,  // AWH - reconcile this
            id_floor: this.id_floor.value,
            rawCoords: this.raw_coords.as_json,
            rawP1P2: this._raw_geo_ref.toJSON(),
            has_coords: this.has_coords
        };
        return r;
    }
    public get toJSON(): AssetJSON {
        return this.as_json;
    }

    // public nudge(rhs: Asset): void {
    //     if (this.category === rhs.category) {
    //         // only nudge if the assets are the same category
    //         if (this.id_floor.equals(rhs.id_floor)) {
    //             // only nudge if the assets are on the same floor
    //             if (!this.id.equals(rhs.id)) {
    //                 // only nudge if the ids don't match
    //                 if (this._adj_coord) {
    //                     if (rhs._adj_coord) {
    //                         Nudge(this._adj_coord, rhs._adj_coord, 45, 20);
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }
}

export class AssetCollection {

    private _assets: any = {};  // {id_asset:Asset}
    private _assets_sorted_by_floor: any = {};   //{(key:string):Id_asset[]} = null;
    private __assets_list: Asset[] = null;  // {id_asset:Asset}
    private __json: any = null;

    public static empty(): AssetCollection { return new AssetCollection(); };
    public constructor() { }

    public get count(): number {
        return this.assets.length;
    }

    public get assets(): Asset[] {

        if (!this.__assets_list) {
            this.__assets_list = [];
            Object.keys(this._assets).forEach((id_asset: string) => {
                this.__assets_list.push(this._assets[id_asset]);
            });
        }
        return this.__assets_list;
    }

    public get as_array(): Asset[] {
        return this.assets;
    }

    public get_asset(id_asset: Id_asset): Asset {
        let r: Asset = this._assets[id_asset.value];
        if (!r) {
            return null;
        }
        return r;
    }


    public get_assets_on_floor(id_floor: Id_floor, filteredAssets: {[key: string]: boolean}, isFilterActive: boolean): AssetCollection {
        let r: AssetCollection = new AssetCollection();
        // When a filter is active, apply it even if it matched nothing (empty filteredAssets
        // then yields an empty result). When inactive, show all assets on the floor.
        const hasFilter = isFilterActive;
        this.assets.forEach((asset: Asset) => {
            if (asset.id_floor && asset.id_floor.equals(id_floor)) {
                if (hasFilter && !filteredAssets[asset.id.value]) {
                    return;
                }
                asset.isValid = true;
                r.add_asset(asset);
            }
        });
        return r;
    }


    public get length(): number {
        return Object.keys(this._assets).length;
    }

    public get validLength(): number {
        let count = 0;
        const keys = this.assets.length;
        for (let i = 0; i < keys; i++) {
            const asset: Asset = this.assets[i];
            if (asset.isValid) {
                count++;
            }
        }
        return count;
    }

    public get isValid(): boolean {
        let isValid = false;
        const keys = Object.keys(this._assets);
        for (let i = 0; i < keys.length; i++) {
            const asset: Asset = this._assets[keys[i]];
            if (asset.isValid) {
                isValid = true;
                break;
            }
        }

        return isValid;
    }

    public static build_from_raw(raw_assets: any[]): Asset[] {
        let r: Asset[] = [];
        raw_assets.forEach((raw_asset: any) => {
            let new_asset: Asset = Asset.build_from_raw(raw_asset);
            if (new_asset) {
                r.push(new_asset);
            }
            else {
                console.error('null asset created by', raw_asset);
            }
        });
        return r;
    }

    public static wrap(assets: Asset[]): AssetCollection {
        let r: AssetCollection = new AssetCollection();
        assets.forEach((asset: any) => {
            r.add_asset(asset);
        });
        return r;
    }

    public add_assets(assets: Asset[]): AssetCollection {
        assets.forEach((asset: Asset) => this.add_asset(asset));
        return this;
    }

    private add_asset(asset: Asset): AssetCollection {
        this._assets[asset.id.value] = asset;

        // add the asset to the floor-sorted table
        if (asset.id_floor) {
            if (!this._assets_sorted_by_floor[asset.id_floor.toString()]) {
                this._assets_sorted_by_floor[asset.id_floor.toString()] = [];
            }
            this._assets_sorted_by_floor[asset.id_floor.toString()].push(asset.id);
        }

        this.__json = null;
        //     this.__assets_sorted_by_floor_json = null;
        this.__assets_list = null;
        return this;
    }

    public add(assets: Asset | Asset[] | AssetCollection): AssetCollection {
        if (assets instanceof AssetCollection) {
            return this.add_assets((<AssetCollection>assets).as_array);
        }
        if (Array.isArray(assets)) {
            return this.add_assets(<Asset[]>assets);
        }
        return this.add_asset(<Asset>assets);
    }

    public get_assets_by_category(category: Category | Id_category, filteredAssets: {[key: string]: boolean}): AssetCollection {
        const hasFilter = Object.keys(filteredAssets).length > 0;
        const assets = hasFilter
            ? this.assets.filter((asset: Asset) => filteredAssets[asset.id.value] === true)
            : this.assets;

        let resultAssets = AssetCollection.empty();

        if (category instanceof Category) {
            resultAssets = AssetCollection.wrap(assets.filter((asset: Asset) => asset.id_category.equals((<Category>category).id_category)));
        } else {
            resultAssets = AssetCollection.wrap(assets.filter((asset: Asset) => asset.id_category.equals(<Id_category>category)));
        }

        return resultAssets;
    }

    public get_assets_by_categories(categories: Id_category[] | Category[], filteredAssets: {[key: string]: boolean}): AssetCollection {
        let retval: AssetCollection = AssetCollection.empty();
        for (var i = 0; i < categories.length; i++) {
            retval.add(this.get_assets_by_category(categories[i], filteredAssets));
        }
        return retval;
    }

    public get_categories(): string[] {
        let mySet = new Set<string>();
        this.assets.forEach((asset: Asset) => mySet.add(asset.id_category.toString()));
        return Array.from(mySet);
    }

    public toJSON(): any {
        return this.as_json;
    }

    public get as_json(): any {
        if (this.__json === null) {
            this.__json = JSON.parse(JSON.stringify(Object.keys(this._assets)));
        }
        return this.__json;
    }

    // returns a JSON object of all assets indexed by floor
    public sorted_by_floor_json(): any {
        let __assets_sorted_by_floor_json: any = {};
        this.assets.forEach((asset: Asset) => {
            if (!asset.id_floor) { return; }
            let id_location: string = asset.id_floor.toString();
            if (!__assets_sorted_by_floor_json[id_location]) {
                __assets_sorted_by_floor_json[id_location] = [];
            }
            __assets_sorted_by_floor_json[id_location].push(asset.toJSON);
        });

        return __assets_sorted_by_floor_json;
    }
}

function utilsAssetIcon(cms_view_icon: string): string {
    if (!exists(cms_view_icon)) {
        return "";
    }
    let icon: string = cms_view_icon;

    if (icon.toLowerCase().substring(0, 4) !== "http") {
        icon = `${Configuration.azureStorageAccountUrl}/cmsview/icons/48/` + icon;
    }
    return icon;
}
